export type TLoadStage = 'app_start' | 'screen_chunk_loaded' | 'hydrate_start' | 'hydrate_end'

export type TRenderMode = 'hydrate' | 'render'

type TLoadStageParams = Record<TLoadStage, number | undefined>

const MARK_PREFIX = 'audio:'

let renderMode: TRenderMode | undefined

const markNameOf = (stage: TLoadStage) => `${MARK_PREFIX}${stage}`

const getMarkTime = (stage: TLoadStage): number | undefined => {
    const [entry] = performance.getEntriesByName(markNameOf(stage), 'mark')

    return entry === undefined ? undefined : Math.round(entry.startTime)
}

export const markLoadStage = (stage: TLoadStage): void => {
    const name = markNameOf(stage)

    if (performance.getEntriesByName(name, 'mark').length > 0) {
        return
    }

    performance.mark(name)
}

export const getLoadStageParams = (): TLoadStageParams => ({
    app_start: getMarkTime('app_start'),
    screen_chunk_loaded: getMarkTime('screen_chunk_loaded'),
    hydrate_start: getMarkTime('hydrate_start'),
    hydrate_end: getMarkTime('hydrate_end'),
})

export const setRenderMode = (mode: TRenderMode): void => {
    renderMode = mode
}

export const getRenderMode = (): TRenderMode | undefined => renderMode
